/**
 * Created by PanJiaChen on 16/11/18.
 */
export default {
  /**
   * @param {string} path
   * @returns {Boolean}
   */
  isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path);
  },

/**
 * 校验用户名,必须是5-32位
 * @param {string} str
 * @returns {Boolean}
 */
isvalidUsername(str) {
  var reg=/^[0-9A-Za-z]{5,32}$/;
  return reg.test(str)
},

/**
 * 校验url链接格式
 * @param {string} url
 * @returns {Boolean}
 */
isvalidUrl(url) {
  var reg=/^((ht|f)tps?):\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?/;
  return reg.test(url)
},

/**
 * 校验邮箱格式
 * @param {string} email
 * @returns {Boolean}
 */
isvalidEmail(email) {
  var reg=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  return reg.test(email)
},

/**
 * 校验正整数
 * @param {string} email
 * @returns {Boolean}
 */
isvalidZNumber(email) {
  var reg=/^\+?[1-9][0-9]*$/;
  return reg.test(email)
},

/**
 * 校验手机号
 * @param {string} value
 * @returns {Boolean}
 */
isvalidPhone(value) {
  var reg=/^1[3456789]\d{9}$/;
  return reg.test(value)
}

}




// WEBPACK FOOTER //
// ./src/utils/validValue.js